import styled from 'styled-components';

const StyledBodySpecialGridSecondaryColumn = styled.section``;

export default StyledBodySpecialGridSecondaryColumn;
